
import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			internalValue: 0,
		};
	},

	props: {
		value: { type: Number, default: 0 },
		unit: { type: String, required: true },
		min: { type: Number },
		max: { type: Number },
		step: { type: Number, default: 1 },
		state: { type: Boolean, default: null },
		id: { type: String, default: 'unit' },
		disabled: { type: Boolean, default: false },
		formGroup: { type: Boolean, default: false },
	},

	mounted() {
		this.internalValue = this.value ?? 0;
	},

	computed: {
		currentValue: {
			get(): number {
				return this.internalValue;
			},
			set(value: number | string) {
				if (typeof value === 'string') {
					this.internalValue = 0;
				} else {
					this.internalValue = value;
				}

				this.$emit('input', this.internalValue);
			},
		},
	},
});
